import React from 'react';
import LoaderSpiner from '../../../components/LoadersSpiner/loader';
import { useTranslation } from 'react-i18next';
import IntegrationFlipCard from '../../../components/IntegrationsComponents/IntegrationFlipCard';
import useIntegrationsCatalog from '../../../hooks/useIntegrationsCatalog';

export const IntegrationsCatalog = ({ showHeader = false, flattenCategories = false }) => {
   const { t } = useTranslation();
   const { safeCategories, isLoading, hasError } = useIntegrationsCatalog();
   const flatIntegrations = flattenCategories
      ? safeCategories.flatMap((category) => {
           const integrations = Array.isArray(category?.integrations)
              ? category.integrations
              : [];
           return integrations.map((integration) => ({
              integration,
              categoryTitle: category?.title || t("category"),
              categoryDescription:
                 category?.description &&
                 category?.description !== category?.title
                    ? category.description
                    : '',
           }));
        })
      : [];

   return (
      <>
         {showHeader ? (
            <div className="row align-items-center mb-55">
               <div className="col-xl-6 col-lg-8 col-md-8 col-sm-8">
                  <div className="section__title section__title-3 mb-30">
                     <span>{t("home_integrations_title_mini")}</span>
                     <h2>{t("home_integrations_title_big")}</h2>
                  </div>
               </div>
            </div>
         ) : null}
         <div className="row">
            {isLoading ? (
               <LoaderSpiner />
            ) : hasError ? (
               <div className="col-12">
                  <div className="integration-error">
                     {t("generic_error_message")}
                  </div>
               </div>
            ) : (
               <div className="col-12">
                  {flattenCategories ? (
                     <div className="row integration-grid">
                        {flatIntegrations.map((item, index) => (
                           <div
                              className="col-xl-4 col-lg-6 col-md-6"
                              key={`integration-flat-${index}`}
                           >
                              <IntegrationFlipCard
                                 integration={item.integration}
                                 category={item.categoryTitle}
                                 categoryDescription={item.categoryDescription}
                              />
                           </div>
                        ))}
                     </div>
                  ) : (
                     <div className="integrations-categories">
                        {safeCategories.map((category, categoryIndex) => {
                           const categoryTitle = category?.title || t("category");
                           const categoryDescription =
                              category?.description &&
                              category?.description !== categoryTitle
                                 ? category.description
                                 : '';
                           const integrations = Array.isArray(category?.integrations)
                              ? category.integrations
                              : [];

                           return (
                              <div className="integration-category" key={`cat-${categoryIndex}`}>
                                 <div className="integration-category__header">
                                    <h3>{categoryTitle}</h3>
                                    {categoryDescription ? (
                                       <p>{categoryDescription}</p>
                                    ) : null}
                                 </div>
                                 <div className="row integration-grid">
                                    {integrations.map((integration, integrationIndex) => (
                                       <div
                                          className="col-xl-4 col-lg-6 col-md-6"
                                          key={`integration-${categoryIndex}-${integrationIndex}`}
                                       >
                                          <IntegrationFlipCard
                                             integration={integration}
                                             category={categoryTitle}
                                             categoryDescription={categoryDescription}
                                          />
                                       </div>
                                    ))}
                                 </div>
                              </div>
                           );
                        })}
                     </div>
                  )}
               </div>
            )}
         </div>
      </>
   );
};

const IntegrationsArea = () => {
   return (
      <>
         <section className="team__area pt-115 pb-110">
            <div className="container">
               <IntegrationsCatalog showHeader />
            </div >
         </section >
      </>
   );
};

export default IntegrationsArea;
